import React, { FC } from 'react';
import { ButtonStyled } from './styles';
import { ButtonProps } from './models';

const SecondaryButton: FC<ButtonProps> = ({ children, ...props }) => {
  return <ButtonStyled {...props}>{children}</ButtonStyled>;
};

export default SecondaryButton;
